import * as React from 'react';
import Svg, { G, Path, SvgProps } from 'react-native-svg';

import { ds } from '@/components/lib/design.system';

export const TieIcon = (props: SvgProps) => (
    <Svg width={12} height={12} viewBox="0 0 12 12" fill="none" {...props}>
        <G id="12 / Equal">
            <Path id="Shape" d="M2 7.5H10" stroke={ds.colorValue.icon.primary} strokeWidth={1.5} />
            <Path id="Shape_2" d="M2 4.5H10" stroke={ds.colorValue.icon.primary} strokeWidth={1.5} />
        </G>
    </Svg>
);
